import { motion, useInView, useAnimation } from "framer-motion";
import { useRef, useEffect } from "react";

export default function Slide({
	children,
	delay,
	className,
	duration = 0.3,
	value,
}) {
	const ref = useRef(null);
	const isInview = useInView(ref, { once: true });
	const controls = useAnimation();

	useEffect(() => {
		if (isInview) {
			controls.start("visible");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInview]);

	return (
		<motion.div
			ref={ref}
			variants={{
				hidden: {
					opacity: 0,
					translateX: value,
				},
				visible: {
					opacity: 1,
					translateX: 0,
				},
			}}
			transition={{
				type: "tween",
				duration: duration,
				damping: 8,
				delay: delay,
				stiffness: 100,
			}}
			initial="hidden"
			animate={controls}
			className={className}
		>
			{children}
		</motion.div>
	);
}
